<div class="inspection-category width-100p">
  <div class="inspection-category-header pointer flex-between-center" [ngClass]="{'b-bottom': isExpanded}"
    (click)="toggleIsExpanded()">
    <div class="d-flex">
      <span class="fal font-gray-45 p-6"
        [ngClass]="{'fa-chevron-down': !isExpanded, 'fa-chevron-up': isExpanded}"></span>
      <span class="flex-start-center">
        <p class="font-bold m-0 ml-2 text-truncate width-20" tooltipPosition="top" [pTooltip]="category?.title">
          {{category?.title}}</p>
        <div class="h-line ml-1 mr-1"></div>
        <p class="m-0 font-4c">
          {{category?.inspectionItems?.length}} item{{category?.length > 1? 's': ''}}
        </p>
      </span>
    </div>
    <div class="flex-between-center" style="padding-right: 21px;">
      <span class="dotted-green ml-2 mr-1">
      </span>
      5
      <span class="dotted-yellow ml-2 mr-1">
      </span>
      8
      <span class="dotted-red ml-2 mr-1">
      </span>
      2
      <span class="dotted-gray ml-2 mr-1">
      </span>
      1
    </div>
  </div>

  <div class="inspection-category-body" *ngIf="isExpanded">
    <div *ngFor="let inspectionItem of category?.inspectionItems" class="inspection-cat-item-wrapper">
      <div [ngClass]="inspectionItem._id === selectedRow && 'active-row'" class="item-row">
        <app-dvi-inspection-category-item [workStatus]="workStatus" (handleActive)="handleSelectRow(inspectionItem)"
          [isArchived]="isArchived" [inspectionItem]="inspectionItem"
          [active]="inspectionItem._id === selectedRow"></app-dvi-inspection-category-item>
      </div>
    </div>
  </div>
</div>